<!--
 * @Descripttion: 
 * @Author: Junteng Shi
 * @Date: 2025-03-06 14:58:24
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-06-09 16:34:24
-->
<template>
  <el-config-provider namespace="el" :message="{ max: 1 }" :locale="elZhCn">
    <n-config-provider :theme-overrides="themeOverrides" :locale="zhCN" :date-locale="dateZhCN" h-full>
      <router-view />
    </n-config-provider>
  </el-config-provider>
</template>
<script setup lang="ts">
import { zhCN, dateZhCN, GlobalThemeOverrides } from 'naive-ui';
import elZhCn from 'element-plus/dist/locale/zh-cn.mjs';
import naiveTheme from '@/styles/naiveUI/index';

const themeOverrides: GlobalThemeOverrides = {
  common: naiveTheme,
}
</script>

<style>
  html,
  body {
    height: 100%;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background-color: var(--color-bg-1);
    height: 100%;
  }
</style>
